// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hy-user-modal .messaging{padding-bottom:15px}
`, "",{"version":3,"sources":["webpack://./src/components/User/index.scss"],"names":[],"mappings":"AAEA,0BAEQ,mBAAoB","sourcesContent":["@import '../../scss/variables';\n\n.hy-user-modal {\n    .messaging {\n        padding-bottom: 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
